import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * Barcode — render an SVG barcode for the given numeric value.
 *
 * Uses Code 128 (compact, dense, supports the full ASCII set — overkill for
 * 8-digit numerics but means we never have to think about format mismatches
 * if the customer-number scheme grows). Phone cameras read it instantly.
 */
const Barcode = ({ value, width = 2, height = 70, displayValue = true, fontSize = 16, className = '', testId }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      JsBarcode(ref.current, String(value), {
        format: 'CODE39',
        width,
        height,
        displayValue,
        fontSize,
        font: 'monospace',
        textMargin: 4,
        margin: 8,
        background: '#FFFFFF',
        lineColor: '#0F172A',
      });
    } catch {
      // bad value (eg empty) — render nothing
    }
  }, [value, width, height, displayValue, fontSize]);

  if (!value) return null;
  return <svg ref={ref} className={className} data-testid={testId || 'barcode-svg'} />;
};

export default Barcode;
